var render = function render(){var _vm=this,_c=_vm._self._c;return _c('alert-modal',{attrs:{"title":_vm.$t('CHANGE_WARNING_TITLE'),"primaryCTAText":_vm.$t('ACTION_CONFIRM'),"secondaryCTAText":_vm.$t('ACTION_CANCEL')},on:{"close":_vm.close,"cancel":_vm.close,"confirm":_vm.confirm,"overlayClick":_vm.close}},[_c('div',{staticClass:"cz2__modal-popup__copy"},[_vm._v(" "+_vm._s(_vm.$t('CHANGE_WARNING_BODY'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }